// extracted by mini-css-extract-plugin
export var accountwrapper = "HeaderDesktop-module--accountwrapper--5dc77";
export var bottomlinkswrapper = "HeaderDesktop-module--bottomlinkswrapper--78db3";
export var burgerwrapper = "HeaderDesktop-module--burgerwrapper--a1080";
export var content = "HeaderDesktop-module--content--cc9c9";
export var contentrightwrapper = "HeaderDesktop-module--contentrightwrapper--f9109";
export var controlswrapper = "HeaderDesktop-module--controlswrapper--abbd1";
export var donatewrapper = "HeaderDesktop-module--donatewrapper--42468";
export var favs = "HeaderDesktop-module--favs--e3b47";
export var favsscrolled = "HeaderDesktop-module--favsscrolled--2c13d";
export var favsscrolledfurther = "HeaderDesktop-module--favsscrolledfurther--a1a1a";
export var headerinner = "HeaderDesktop-module--headerinner--65722";
export var headerouter = "HeaderDesktop-module--headerouter--4128f";
export var listanchorscrolled = "HeaderDesktop-module--listanchorscrolled--32d11";
export var listlink = "HeaderDesktop-module--listlink--87758";
export var listlinkanchor = "HeaderDesktop-module--listlinkanchor--0e618";
export var listlinkscrolled = "HeaderDesktop-module--listlinkscrolled--2624c";
export var listoflinks = "HeaderDesktop-module--listoflinks--1acd9";
export var logowrapperbottom = "HeaderDesktop-module--logowrapperbottom--155fc";
export var logowrapperbottomscrolled = "HeaderDesktop-module--logowrapperbottomscrolled--953d6";
export var logowrappertop = "HeaderDesktop-module--logowrappertop--b6885";
export var primarylink = "HeaderDesktop-module--primarylink--1002d";
export var primarylinks = "HeaderDesktop-module--primarylinks--ad4d2";
export var primarylinksscrolled = "HeaderDesktop-module--primarylinksscrolled--ad0e3";
export var searchbox = "HeaderDesktop-module--searchbox--86c0c";
export var searchboxwrapper = "HeaderDesktop-module--searchboxwrapper--b7a8a";